<div *ngIf="filteredButtons$ | async; let filteredButtons">
  <button mat-icon-button
      *ngIf="filteredButtons.length"
      color="accent"
      class="more-button"
      [matMenuTriggerFor]="menu"
      [attr.aria-label]="ariaLabel"
      (menuOpened)="menuOpened()"
      (menuClosed)="menuClosed()"
      i18n-aria-label
  >
    <mat-icon *ngIf="!isSVGIcon">{{ menuIcon }}</mat-icon>
    <svg *ngIf="isSVGIcon"
         aria-hidden="true"
         focusable="false"
         data-prefix="fas"
         role="img"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 640 512">
      <path fill="currentColor" [attr.d]="menuIcon"></path>
    </svg>
  </button>

  <mat-menu #menu="matMenu" xPosition="before">
    <ng-container *ngFor="let item of filteredButtons">
      <a mat-menu-item color="primary" *ngIf="item.type === 'link'" [routerLink]="item.link | async" [queryParams]="item.queryParams ?? {}">{{ item.label }}</a>
      <button mat-menu-item *ngIf="item.type === 'button'" color="primary" (click)="item.click()">{{ item.label }}</button>
    </ng-container>
  </mat-menu>
</div>
